import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";

import * as CampaignActions from "../../../store/actions/Campaign";
import * as FeatureActions from "../../../store/actions/Feature";
import * as UserActions from "./../../../store/actions/User";
import { getInitialState } from "../../../utils";
import {
  isValidated,
  filterObj,
  getReadableDateTime,
  getSortedListForStw,
} from "../../../utils";
import Permission from "../../Common/Permission";
import MenuNames from "../../../constants/Menu/MenuNames.json";
import MenuActionsMappings from "../../../constants/Menu/MenuActionsMappings";
import NoFooterModal from "../../Common/NoFooterModal";
import Input from "sushiweb/InputTypes/Input";
import PaginatedReactDropdown from "../../Common/PaginatedReactDropdown";
import { BottomSectionModal } from "../../../constants/assets/containers";
import Button from "sushiweb/Button";
import Autocomplete from "@material-ui/lab/Autocomplete";
import TextField from "@material-ui/core/TextField";
import Textarea from "sushiweb/InputTypes/Textarea";
import variables from "../../../constants/assets/variables";
import _ from "lodash-es";

const mandatoryFields = [
  "name",
  "start_date",
  "spin_end_date",
  "game_end_date",
  "campaign_type",
  "active",
  "metadata",
  "is_weekly_recurring",
  "percentages",
  "major_inventories_applicable",
  "medium_inventories_applicable",
  "category",
  "campaign_game_type",
];

const applicableOptions = [
  { key: "true", label: "true" },
  { key: "false", label: "false" },
];

const campaignGameTypeOptions = [
  { key: "SPIN_THE_WHEEL", label: "Spin the wheel" },
  { key: "ROLL_&_WIN", label: "Roll & win" },
];

const stwCampaignTypes = ["RAIN", "FESTIVAL"];

const isCampaignNameValid = (name) => {
  const regex = /^[a-zA-Z0-9 -]+$/;
  return regex.test(name);
};

const isValidSTWCampaignType = (name) => stwCampaignTypes.includes(name);

export const CampaignFormModal = (props) => {
  const {
    modalState,
    handleClose,
    activeItem,
    activeCampaign,
    activeFilters,
    filterFields,
    currentPage,
    setStatus,
    setActiveCampaign,
    resetState,
  } = props;
  const allActions = MenuActionsMappings[MenuNames.CAMPAIGNS];
  const [initialState, setInitialState] = useState({
    id: activeCampaign.id,
    name: "",
    start_date: "",
    spin_end_date: "",
    game_end_date: "",
    campaign_type: "",
    active: false,
    metadata: "",
    is_weekly_recurring: false,
    percentages: "",
    major_prize_percentages: "",
    major_inventories_applicable: false,
    medium_inventories_applicable: false,
    category: "",
    campaign_game_type: "",
    created_at: "",
    updated_at: "",
  });

  const handleSubmit = (e) => {
    e.preventDefault();

    const body = filterObj(initialState, [
      "id",
      "name",
      "start_date",
      "spin_end_date",
      "game_end_date",
      "campaign_type",
      "active",
      "metadata",
      "is_weekly_recurring",
      "percentages",
      "major_prize_percentages",
      "major_inventories_applicable",
      "medium_inventories_applicable",
      "category",
      "campaign_game_type",
      "created_at",
      "updated_at",
    ]);
    //if filter button is clicked then apply filters
    if (modalState === "Filter") {
      let filters = {};

      const regex = /Id:\s*(\d+)/;
      const match = body["name"].match(regex);
      if (match) {
        const id = match[1];
        filters["id"] = id;
      } else {
        setStatus({
          type: "error",
          message: `Id not found in the selected campaign.`,
        });
        return;
      }

      props.getCampaignList(filters).then((res) => {
        handleClose();
      });
    } else {
      //before hitting api, check if all validations like mandatory fields are satisfied
      let validatedState = isValidated(body, mandatoryFields);
      let metadata = body["metadata"];
      // `info` should be in correct json format
      if (!isCampaignNameValid(body["name"])) {
        setStatus({
          type: "error",
          message: `Invalid campaign name`,
        });
        return;
      }

      if (body["campaign_game_type"] === "SPIN_THE_WHEEL") {
        if (!isValidSTWCampaignType(body["campaign_type"])) {
          setStatus({
            type: "error",
            message: `Invalid campaign type! must be one of ${stwCampaignTypes.join(
              ","
            )} `,
          });
          return;
        }
      }

      try {
        if (metadata === "") {
          metadata = "null";
        }
        JSON.parse(metadata);
        metadata = JSON.stringify(metadata);
      } catch {
        validatedState = "value of `metadata` is not in correct JSON format";
      }

      const startDate = new Date(body["start_date"]);
      const spinEndDate = new Date(body["spin_end_date"]);
      const gameEndDate = new Date(body["game_end_date"]);
      if (isNaN(startDate)) {
        setStatus({
          type: "error",
          message: `Invalid start date`,
        });
        return;
      }
      if (isNaN(spinEndDate)) {
        setStatus({
          type: "error",
          message: `Invalid spin end date`,
        });
        return;
      }
      if (isNaN(gameEndDate)) {
        setStatus({
          type: "error",
          message: `Invalid game end date`,
        });
        return;
      }
      if (startDate <= spinEndDate && spinEndDate <= gameEndDate) {
      } else {
        setStatus({
          type: "error",
          message: "Dates are not in ascending order",
        });
        return;
      }

      let percentagesArray;
      let majorPrizePercentagesArray;
      try {
        percentagesArray = JSON.parse(body["percentages"]);
        if (
          body["major_prize_percentages"] != null &&
          body["major_prize_percentages"] != ""
        ) {
          majorPrizePercentagesArray = JSON.parse(
            body["major_prize_percentages"]
          );
          if (percentagesArray.length === majorPrizePercentagesArray.length) {
            for (let i = 0; i < percentagesArray.length; i++) {
              if (
                percentagesArray[i] > 100 ||
                majorPrizePercentagesArray > 100 ||
                percentagesArray[i] < 0 ||
                majorPrizePercentagesArray < 0 ||
                percentagesArray[i] < majorPrizePercentagesArray[i]
              ) {
                setStatus({
                  type: "error",
                  message:
                    "Percentages should be greater than Major Prize Percentages",
                });
                return;
              }
            }
          } else {
            setStatus({
              type: "error",
              message:
                "Percentages and Major Prize Percentages does not contain equal numbers i.e. 3",
            });
            return;
          }
        } else {
          delete body.major_prize_percentages;
        }
      } catch {
        validatedState = "Percentages should be in valid format: [X,Y,Z]";
      }
      if (body["active"] == "true") {
        body["active"] = true;
      }
      if (body["active"] == "false") {
        body["active"] = false;
      }
      if (body["is_weekly_recurring"] == "true") {
        body["is_weekly_recurring"] = true;
      }
      if (body["is_weekly_recurring"] == "false") {
        body["is_weekly_recurring"] = false;
      }
      if (body["major_inventories_applicable"] == "true") {
        body["major_inventories_applicable"] = true;
      }
      if (body["major_inventories_applicable"] == "false") {
        body["major_inventories_applicable"] = false;
      }
      if (body["medium_inventories_applicable"] == "true") {
        body["medium_inventories_applicable"] = true;
      }
      if (body["medium_inventories_applicable"] == "false") {
        body["medium_inventories_applicable"] = false;
      }
      if (body["id"] == "") {
        body["id"] = 0;
      }
      body["start_date"] = startDate.toISOString();
      body["spin_end_date"] = spinEndDate.toISOString();
      body["game_end_date"] = gameEndDate.toISOString();

      if (validatedState === "validated") {
        props.updateCampaign(body).then((res) => {
          let pageRequest = {
            page: currentPage,
          };
          props.getCampaignList(activeFilters, pageRequest);
          handleClose();
        });
      } else {
        setStatus({
          type: "error",
          message: validatedState,
        });
      }
    }
  };

  const handleClose2 = () => {
    setActiveCampaign({});
    handleClose();
  };

  const handleClearFilters = () => {
    props.getCampaignList({}).then((res) => {
      props.resetState({ state: "activeFilters" });
      handleClose();
    });
  };

  const handleChange = (key, val) => {
    let values = { ...initialState };
    values[key] = val;
    setInitialState(values);
  };

  const isFilterApplicable = (value) => {
    if (modalState === "Filter" && filterFields) {
      return !filterFields.includes(value) ? true : false;
    } else {
      return false;
    }
  };
  const getRequiredButtonPerms = (action = undefined) => {
    if (modalState === "Edit") {
      return [allActions.UPDATE];
    } else if (modalState === "Add") {
      return [allActions.BULK_CREATE];
    }
    return undefined;
  };

  //reset feature list
  useEffect(() => {
    modalState == "Filter"
      ? props.getCampaignList({}, { pageSize: 1000 })
      : props.resetState({ state: "campaignsList" });
  }, [modalState]);

  useEffect(() => {
    if (activeItem) {
      props.setActiveCampaign(activeItem);
    }
  }, [activeItem, modalState]);

  useEffect(() => {
    //set the initial state of form in modal
    if (activeCampaign && modalState === "Edit") {
      let values = { ...initialState };
      Object.keys(values).map((key, idx) => {
        values[key] = activeCampaign[key]
          ? activeCampaign[key]
          : getInitialState(initialState, key);
      });

      setInitialState(values);
    }
    if (activeFilters && modalState === "Filter") {
      let values = { ...initialState };
      Object.keys(values).map((key, idx) => {
        values[key] = activeFilters[key] ? activeFilters[key] : "";
      });
      setInitialState(values);
    }
  }, [activeCampaign, activeFilters]);
  const getModalButtons = () => {
    return (
      <BottomSectionModal className="flex items-center justify-between">
        {modalState === "Filter" && (
          <Button
            data-testid="filterFeatureBtn"
            onClick={handleClearFilters}
            className="sushi-btn"
          >
            Clear
          </Button>
        )}
        {/* <Permission requiredPerms={getRequiredButtonPerms()}> */}
        <Button
          data-testid="submitButton"
          className="sushi-btn"
          onClick={handleSubmit}
        >
          {modalState === "Filter" ? "Apply" : "Submit"}
        </Button>
        {/* </Permission> */}
      </BottomSectionModal>
    );
  };

  return (
    <>
      <NoFooterModal
        header={true}
        heading={`Campaign Form`}
        handleClose={handleClose2}
        id="FeatureFormModal"
        modalButtons={getModalButtons()}
      >
        {modalState == "Filter" ? (
          <Autocomplete
            value={initialState.name}
            onChange={(event, newValue) => {
              handleChange("name", newValue);
            }}
            closeIcon={false}
            data-testid="featureName"
            id="controllable-states-demo"
            options={getSortedListForStw(props.campaignList)}
            style={{ width: 300 }}
            renderInput={(params) => (
              <TextField {...params} label="Campaign Name" variant="outlined" />
            )}
          />
        ) : (
          <Input
            value={initialState.name}
            data-testid="campaignName"
            id="sushi-input"
            onChange={(e) => handleChange("name", e)}
            label="Name"
          />
        )}

        {modalState === "Edit" ? (
          <Input
            value={initialState.start_date}
            data-testid="start_date"
            id="sushi-input"
            fullWidth={true}
            label="Start Date (Example: Thu Jun 15 2023 5:30:00 AM)"
            onChange={(e) => handleChange("start_date", e)}
          />
        ) : (
          ""
        )}

        {modalState === "Edit" ? (
          <Input
            value={initialState.spin_end_date}
            data-testid="spin_end_date"
            id="sushi-input"
            fullWidth={true}
            label="Spin End Date (Example: Thu Jun 15 2023 5:30:00 AM)"
            onChange={(e) => handleChange("spin_end_date", e)}
          />
        ) : (
          ""
        )}

        {modalState === "Edit" ? (
          <Input
            value={initialState.game_end_date}
            data-testid="game_end_date"
            id="sushi-input"
            fullWidth={true}
            label="Game End Date (Example: Thu Jun 15 2023 5:30:00 AM)"
            onChange={(e) => handleChange("game_end_date", e)}
          />
        ) : (
          ""
        )}

        {modalState === "Edit" ? (
          <Input
            value={initialState.campaign_type}
            data-testid="campaign-type"
            id="sushi-input"
            onChange={(e) => handleChange("campaign_type", e)}
            label="Campaign Type"
          />
        ) : (
          ""
        )}

        {modalState === "Edit" ? (
          <PaginatedReactDropdown
            options={applicableOptions}
            data-testid="featureActive"
            labelKey="label"
            valueKey="key"
            labelWidth="8%"
            disabled={isFilterApplicable("active")}
            value={initialState.active.toString()}
            handleChange={handleChange}
            keyToChange="active"
            placeholder="Active"
            showCross={false}
            id="campaignStatusDropdown"
          />
        ) : (
          ""
        )}

        {modalState === "Edit" ? (
          <Textarea
            id="sushi-textarea"
            data-testid="metadata"
            borderColor={variables.primaryColor}
            innerWidth="100%"
            className="mb-20"
            resize="none"
            label="Metadata"
            disabled={false}
            onChange={(e) => handleChange("metadata", e)}
            value={initialState.metadata}
          />
        ) : (
          ""
        )}

        {modalState === "Edit" ? (
          <PaginatedReactDropdown
            options={applicableOptions}
            data-testid="is-weekly-recurring"
            labelKey="label"
            valueKey="key"
            labelWidth="100%"
            disabled={isFilterApplicable("is_weekly_recurring")}
            value={initialState.is_weekly_recurring.toString()}
            handleChange={handleChange}
            keyToChange="is_weekly_recurring"
            placeholder="Is Weekly Recurring"
            showCross={false}
            id="isWeeklyRecurringDropdown"
          />
        ) : (
          ""
        )}

        {modalState === "Edit" ? (
          <Input
            value={initialState.percentages}
            data-testid="percentages"
            id="sushi-input"
            onChange={(e) => handleChange("percentages", e)}
            label="Percentages (Example: [10,20,30])"
          />
        ) : (
          ""
        )}

        {modalState === "Edit" ? (
          <Input
            value={initialState.major_prize_percentages}
            data-testid="major_prize_percentages"
            id="sushi-input"
            onChange={(e) => handleChange("major_prize_percentages", e)}
            label="Major Prize Percentages (Example: [10,20,30])"
          />
        ) : (
          ""
        )}

        {modalState === "Edit" ? (
          <PaginatedReactDropdown
            options={applicableOptions}
            data-testid="major-inventories-applicable"
            labelKey="label"
            valueKey="key"
            labelWidth="100%"
            disabled={isFilterApplicable("major_inventories_applicable")}
            value={initialState.major_inventories_applicable.toString()}
            handleChange={handleChange}
            keyToChange="major_inventories_applicable"
            placeholder="Major Inventories Applicable"
            showCross={false}
            id="majorInventoriesApplicableDropdown"
          />
        ) : (
          ""
        )}

        {modalState === "Edit" ? (
          <PaginatedReactDropdown
            options={applicableOptions}
            data-testid="medium-inventories-applicable"
            labelKey="label"
            valueKey="key"
            labelWidth="100%"
            disabled={isFilterApplicable("medium_inventories_applicable")}
            value={initialState.medium_inventories_applicable.toString()}
            handleChange={handleChange}
            keyToChange="medium_inventories_applicable"
            placeholder="Medium Inventories Applicable"
            showCross={false}
            id="mediumInventoriesApplicableDropdown"
          />
        ) : (
          ""
        )}

        {modalState === "Edit" ? (
          <Input
            value={initialState.category}
            data-testid="category"
            id="sushi-input"
            onChange={(e) => handleChange("category", e)}
            label="Category"
          />
        ) : (
          ""
        )}

        {modalState === "Edit" ? (
          <PaginatedReactDropdown
            options={campaignGameTypeOptions}
            data-testid="campaign-game-type"
            labelKey="label"
            valueKey="key"
            labelWidth="100%"
            disabled={isFilterApplicable("campaign_game_type")}
            value={initialState.campaign_game_type.toString()}
            handleChange={handleChange}
            keyToChange="campaign_game_type"
            placeholder="Campaign Game Type"
            showCross={false}
            id="campaignGameTypeApplicableDropdown"
          />
        ) : (
          ""
        )}

        {modalState === "Edit" && initialState.created_at != "" ? (
          <Input
            value={getReadableDateTime(initialState.created_at)}
            data-testid="created_at"
            id="sushi-input"
            disabled
            label="Created At"
          />
        ) : (
          ""
        )}

        {modalState === "Edit" && initialState.updated_at != "" ? (
          <Input
            value={getReadableDateTime(initialState.updated_at)}
            data-testid="updated_at"
            id="sushi-input"
            disabled
            label="Updated At"
          />
        ) : (
          ""
        )}
      </NoFooterModal>
    </>
  );
};

function mapStateToProps(state) {
  const { Campaign = {} } = state;
  return {
    activeCampaign: Campaign.activeCampaign,
    activeFilters: Campaign.activeFilters,
    currentPage: Campaign.currentPage,
    campaignList: Campaign.campaignList,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    updateCampaign: bindActionCreators(
      CampaignActions.updateCampaign,
      dispatch
    ),
    getCampaignList: bindActionCreators(
      CampaignActions.getCampaignList,
      dispatch
    ),
    setStatus: bindActionCreators(UserActions.setStatus, dispatch),
    resetState: bindActionCreators(CampaignActions.resetState, dispatch),
    setActiveCampaign: bindActionCreators(
      CampaignActions.setActiveCampaign,
      dispatch
    ),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(CampaignFormModal);
